/**
 * Key roots outside the ["tenant", ...] prefix: tenant switches must not purge
 * them, so identity-change evictions are the only cross-user guard.
 */
export const ALL_BRAND_CAMPAIGNS_QUERY_KEY = "all-brand-campaigns";
export const ALL_BRAND_MEMBER_COUNTS_QUERY_KEY = "all-brand-member-counts";
export const ALL_BRAND_ACCESS_QUERY_KEY = "all-brand-access";

export const CROSS_TENANT_QUERY_KEY_ROOTS = [
  ALL_BRAND_CAMPAIGNS_QUERY_KEY,
  ALL_BRAND_MEMBER_COUNTS_QUERY_KEY,
  ALL_BRAND_ACCESS_QUERY_KEY,
] as const;
